import { ThemeProps } from '@hhgtech/hhg-components'
import styled from 'styled-components'

export const StyledTableOfContent = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  .organisation {
    text-decoration: none;
  }

  --font-weight-lg: ${(props: ThemeProps) => props.theme.sizes.fwBold};
  --font-weight-md: ${(props: ThemeProps) => props.theme.sizes.fwSemiBold};
  --font-weight-sm: ${(props: ThemeProps) => props.theme.sizes.fwRegular};
  &[data-size='lg'] {
    font-size: 18px;
    font-weight: var(--font-weight-lg);
    line-height: 26px;
  }
  &[data-size='md'] {
    font-size: 16px;
    font-weight: var(--font-weight-md);
    line-height: 24px;
  }
  &[data-size='sm'] {
    font-size: 14px;
    font-weight: var(----font-weight-sm);
    line-height: 22px;
  }
`

export const StyledContent = styled.span`
  color: ${(props: ThemeProps) => props.theme.colors.secondaryBase};
`
export const StyledRefContent = styled.a`
  color: ${(props: ThemeProps) => props.theme.colors.secondaryBase};
  text-decoration: auto;
`
export const StyledSeparator = styled.span`
  margin: 0 0.4em;
  color: ${(props: ThemeProps) => props.theme.colors.neutral300};
`
